import { Link } from 'react-router-dom';

// material-ui
import { ButtonBase } from '@mui/material';
import Logo from '../../../utils/Logo';
import config from 'config';

const LogoSection = () => (
    <ButtonBase disableRipple component={Link} to={config.defaultPath}>
        <Logo width={100} />
    </ButtonBase>
);

export default LogoSection;
